import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
import DashboardHeading from '../commonFiles/DashboardHeading';
import AddEmployee from './AddEmployee';
import AddEmployeeDetailsPopup from './AddEmployeeDetailsPopup';

class ViewEmployee extends Component {
  constructor() {
    super();
    this.state = {
      all_table_row:'',
      open_popup:'',
      emp_info_popup:'',
    };
  }

  delete_emp_login(){

  }
  add_other_emp_info(id,first_name,last_name){
    var fullname = first_name+" "+last_name;
    var emp_info_popup = <AddEmployeeDetailsPopup close_popup_view={this.close_emp_popup.bind(this)} fullname={fullname} emp_id={id}/>;
    this.setState({emp_info_popup});
    setTimeout(function (){window.model_show();},100);
  }
  close_emp_popup(){
    window.model_hide();
    var emp_info_popup = '';
    this.setState({emp_info_popup});
  }
  show_table_list(emp_list){
    var list_data = emp_list['msg'];
    var all_table_row = [];

    for(var i=0; i<list_data.length;i++){
      var no            = i;
      var id            = list_data[i]['id'];
      var first_name    = list_data[i]['first_name'];
      var last_name     = list_data[i]['last_name'];
      var emp_type      = list_data[i]['emp_type'];
      var email         = list_data[i]['email'];
      var mobile_no     = list_data[i]['mobile_no'];
      var edit_td       = <td></td>;
      var add_info_td   = <td></td>;
      //var delete_td     = <td></td>;
      if(emp_type!=='Super Admin'){
        edit_td = <td><a className="pointer" title="Edit Employee Details" onClick={this.edit_employee_info.bind(this,id,first_name,last_name,emp_type,email,mobile_no)}><i class="fas fa-user-edit" aria-hidden="true"></i></a></td>;
        add_info_td = <td><a className="pointer" title="Add Employee Details" onClick={this.add_other_emp_info.bind(this,id,first_name,last_name)}><i class="fas fa-folder-plus" aria-hidden="true"></i></a></td>;
        //delete_td =<td><a className="pointer" title="Delete Employee" onClick={this.delete_emp_login.bind(this,id,first_name,last_name)}><i class="fas fa-user-minus" aria-hidden="true"></i></a></td>;
      }
      all_table_row.push(<tr>
      <th scope="row">{no+1}</th>
      <td>{first_name}</td>
      <td>{last_name}</td>
      <td>{list_data[i]['email']}</td>
      <td>{mobile_no}</td>
      <td>{emp_type}</td>
      {edit_td}
      {add_info_td}
      </tr>);
    }
    this.setState({all_table_row});
  }


  edit_employee_info(id,first_name,last_name,emp_type,email,mobile_no){
    var open_popup = <AddEmployee close_popup_view={this.close_popup.bind(this)} emp_id={id} first_name={first_name} last_name={last_name} emp_type={emp_type} email={email} mobile_no={mobile_no} page_titlte="Update Employee"/>;
    this.setState({open_popup});
    setTimeout(function (){window.model_show();},100);
  }

  get_emp_list(){
    let cutThis = this;
    var web_token = $('#web_token').val();
     var body = new FormData();
     body.append('web_token',web_token);
     body.append('function','get_employee_list');
     var url      = '';
     if(window.location.host ==="localhost:3000"){
       url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
     }else{
       url = "/php/admin_employee_management_url.php";
     }
     axios({
          method: 'POST',
          url: url,
          data: body
      })
      .then(function (res) {
        var emp_list = res.data;
        cutThis.show_table_list(emp_list);
      })
      .catch(function (error) {
          console.log(error);
      });

  }

componentDidMount(){
  this.get_emp_list();
}


open_view_popup(id){
  var open_popup = <AddEmployee close_popup_view={this.close_popup.bind(this)} emp_id='0' first_name='' last_name='' emp_type='' email='' mobile_no="" page_titlte="Add Employee"/>;
  this.setState({open_popup});
  setTimeout(function (){window.model_show();},100);
}
close_popup(){
  window.model_hide();
  var open_popup = '';
  this.setState({open_popup});
  this.get_emp_list();
}

  render() {
    return (
        <>
        <DashboardHeading title="Employee List"/>
        	<div className="container mt-4 mb-4 Dashboard_main_div">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">Employee List</h3>


                <div className="row g-4">

                <div className="col-md-6">
                <div className="form-floating">
                    <input type="text" className="form-control" id="full_name" placeholder="Search"/>
                    <label for="name">Search</label>
                </div>
                </div>

                <div className="col-md-3">
                      <button className="btn btn-primary w-100 py-3" type="button">Search</button>
                </div>
                <div className="col-md-3">
                      <button className="btn btn-primary w-100 py-3" type="button" onClick={this.open_view_popup.bind(this)}>Add Employee</button>
                </div>

                <table class="table">
                <thead>
                <tr>
                <th scope="col">#</th>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Email</th>
                <th scope="col">Mobile</th>
                <th scope="col">Role</th>
                <th colspan="2" className="text_align_center">Action</th>
                </tr>
                </thead>
                <tbody>
                {this.state.all_table_row}
                </tbody>
                </table>

            </div>
        </div>
        {this.state.open_popup}
        {this.state.emp_info_popup}
        </>
    );
  }
}

export default ViewEmployee;
